/* ─────────────────────  src/components/courses/CoursesCard.jsx  ───────────────────── */
import React, { useState, useEffect } from "react";
import "./courses.css";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

const CoursesCard = () => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const snap = await getDocs(collection(db, "courses"));
        const list = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setCourses(list);
      } catch (err) {
        console.error("Error fetching courses:", err);
      }
    })();
  }, []);

  return (
    <section className="coursesCard">
      <div className="container grid2">
        {courses.map((course) => (
          <div key={course.id} className="items">
            <div className="content flex">
              <div className="left">
                <div className="img">
                  <img src={course.ImageURL} alt={course.ProgramName} />
                </div>
              </div>
              <div className="text">
                <h1>{course.ProgramName}</h1>
                <div className="rate">
                  <i className="fa fa-star" />
                  <i className="fa fa-star" />
                  <i className="fa fa-star" />
                  <i className="fa fa-star" />
                  <i className="fa fa-star" />
                  <label>(5.0)</label>
                </div>
                <div className="details">
                  {/* <div className='box'>
<div className='dimg'>
  <img src={"./logo-removebg.png"} alt='' />
</div>
<div className='para'>
  <h4>by WELSH EDUCATION GROUP</h4>
</div>
</div> */}
                  <span>{course.ProgramDescription}</span>
                </div>
              </div>
            </div>
            <button className="outline-btn">ENROLL NOW !</button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CoursesCard;
/* ─────────────────────────────  End of file  ───────────────────────────── */










